<template>
  <div>
    <div class="bg-black text-white px-3 relative mb-10 py-8">
      <div class="w-full mb-14 flex justify-center flex-col items-center font-title">
<!--        <img src="/logo_e_white.svg" width="90" height="90" alt="icon arrow">-->
        <img :src="logo_white" width="90" height="90" alt="icon arrow">
        <p class="text-3xl md:text-4xl ">Horse Show Results</p>
        <p class="text-3xl md:text-4.8xl">{{show.name + ' ' + new Date(show.date_start).getFullYear()}}</p>
        <div class="absolute left-0 top-[7%] rotate-[-15deg]">
          <img src="/icon_cup_frame.svg" class="w-full h-full max-w-[220px] " width="90" height="90" alt="icon arrow">
        </div>
      </div>
      <div class="w-full flex  flex-row justify-center content-end absolute bottom-[-30px]">
        <div class="w-[75px] h-[75px] rounded-full bg-white flex justify-center items-center" v-if="show.aa">
          <NuxtLink  aria-label="all-american-standings" to="/all-american-standings" class="block hover:opacity-70 ease-in-out focus:bg-white"
                    style="background: url(/img/horse_shows_buttons.png) 0 0 no-repeat;width:62px;height:62px;"> </NuxtLink>
        </div>
        <div class="w-[75px] h-[75px] rounded-full bg-white flex justify-center items-center">
          <div @click="changePage('')" class="block  hover:opacity-70 ease-in-out focus:bg-white cursor-pointer"
               style="background: url(/img/horse_shows_buttons.png) -62px 0 no-repeat;width:62px;height:62px;"></div>
        </div>
        <div class="w-[75px] h-[75px] rounded-full bg-white flex justify-center items-center" v-if="show.albums">
          <div  @click="changePage('photos')" class="block hover:opacity-70 ease-in-out focus:bg-white cursor-pointer"
               style="background: url(/img/horse_shows_buttons.png) -126px 0 no-repeat;width:62px;height:62px;"></div>
        </div>
        <div class="w-[75px] h-[75px] rounded-full bg-white flex justify-center items-center" v-if="show.videos">
          <div  @click="changePage('videos')" class="block hover:opacity-70 ease-in-out focus:bg-white cursor-pointer"
               style="background: url(/img/horse_shows_buttons.png) -189px 0 no-repeat;width:62px;height:62px;"></div>
        </div>
        <div class="w-[75px] h-[75px] rounded-full bg-white flex justify-center items-center" v-if="show.judge_cards">
          <div  @click="changePage('judgecards')" class="block  hover:opacity-70 ease-in-out focus:bg-white cursor-pointer"
               style="background: url(/img/horse_shows_buttons.png) -313px 0 no-repeat;width:62px;height:62px;"></div>
        </div>
        <div class="w-[75px] h-[75px] rounded-full bg-white flex justify-center items-center" v-if="show.photo_link">
          <NuxtLink  target="_blank" aria-label="photographer" :href="show.photo_link" class="block  hover:opacity-70 ease-in-out focus:bg-white"
                    style="background: url(/img/horse_shows_buttons.png) -375px 0 no-repeat;width:62px;height:62px;"></NuxtLink>
        </div>
      </div>
    </div>


    <div>

      <div class="flex flex-row text-base sm:text-2xl md:text-3xl.5">
        <div class="basis-2/4 flex flex-col px-1">
          <div class="flex items-center mb-1 sm:mb-3">
            <img src="/icons/location.svg" class="mr-1 sm:mr-5" width="23" height="23" alt="location icon">
            <p><span class="font-bold">Location:</span> {{ show.city }} , {{ show.state }}</p>
          </div>
          <div class="flex items-center mb-1 sm:mb-3">
            <img src="/calendar-show-horse.svg" class="mr-1 sm:mr-5" width="23" height="23" alt="location icon">
            <p><span class="font-bold">Date:</span> {{
                new Intl.DateTimeFormat('default', {    timeZone: 'utc',month: 'short', day: 'numeric'}).format(new Date(show.date_start)) +
                '-' + new Intl.DateTimeFormat('default', {    timeZone: 'utc',day: 'numeric'}).format(new Date(show.date_end))
              }}, {{ new Date(show.date_start).getFullYear() }}</p>
          </div>
          <div class="flex items-center mb-1 sm:mb-3">
            <img src="/judge-icon.svg" class="mr-1 sm:mr-5" width="23" height="23" alt="location icon">
            <p><span class="font-bold">Judge:</span> {{ show.judge }}</p>
          </div>
        </div>
        <div class="basis-2/4 flex flex-col p-1">
          <div class="flex items-center mb-1 sm:mb-3">
            <p><span class="font-bold">AA Qualifying:</span> {{ show.usaf ? 'Yes' : 'No' }}</p>
          </div>
          <div class="flex items-center mb-1 sm:mb-3">
            <p><span class="font-bold">Event Entries:</span> {{ options[show.nr_of_horses].name }}</p>
          </div>
        </div>
      </div>







    </div>

    <div class="flex" v-if="ready">
      <div v-if="!isLoggedIn && type != 'videos' && type != 'photos' && type != 'judgecards' " class="text-center w-full pt-10 pb-6">
<!--        <svg class="w-10 inline-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">-->
<!--          <path-->
<!--              d="M80 192V144C80 64.47 144.5 0 224 0C303.5 0 368 64.47 368 144V192H384C419.3 192 448 220.7 448 256V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V256C0 220.7 28.65 192 64 192H80zM144 192H304V144C304 99.82 268.2 64 224 64C179.8 64 144 99.82 144 144V192z"/>-->
<!--        </svg>-->
        <template v-if="arabian">
          <h2 class="text-[28px] md:text-[41px] max-w-[570px] mx-auto font-normal font-title uppercase">This area is restricted to members</h2>
        </template>
        <template v-else>
          <h2 class="text-[28px] md:text-[41px] max-w-[570px] mx-auto font-normal font-title uppercase">This area is restricted to subscribers</h2>
          <p class="font-normal text-2xl mb-8">You need to have an active print or digital subscription</p>
        </template>


        <div class="flex flex-col justify-center sm:flex-row bg-blackLight max-w-[820px] mx-auto mb-4 sm:mb-10 min-h-[330px]">

          <div class="w-full sm:basis-1/2 relative">
            <div class="absolute  top-[-100px] left-[-2%] sm:top-[-20px] sm:left-[-20px] z-[1] opacity-20 sm:opacity-100">
              <nuxt-img
                  format="webp"
                  preload
                  src="/subscribe/member-img-horse.png" alt="member subscribe" width="401" height="363"/>
            </div>
          </div>
          <div class="w-full sm:basis-1/2 flex flex-col justify-center z-[2]">
            <template v-if="arabian">
            <NuxtLink to="/login" class="min-w-[250px] mx-auto uppercase text-lg font-bold bg-white text-black p-3 hover:bg-veryDarkGray hover:text-white border-2 hover:border-white ">register</NuxtLink>
            </template>
            <template v-else>
              <NuxtLink to="/subscribe" class="min-w-[250px] mx-auto uppercase text-lg font-bold bg-white text-black p-3 hover:bg-veryDarkGray hover:text-white border-2 hover:border-white ">subscribe</NuxtLink>
            </template>
              <div v-if="!userName" class="min-w-[250px] mx-auto">
            <p class="py-2 text-grayLight text-tiny">OR</p>
              <p class="text-white mb-2">Are You a Member?</p>
            </div>
            <NuxtLink v-if="!userName" to="/login" class="min-w-[250px] mx-auto uppercase text-lg font-bold p-3 border-2 border-white hover:bg-darkRed text-white">login</NuxtLink>
          </div>
        </div>
      </div>
      <div v-else class="pb-6 pt-6 w-full m-auto">
        <div  v-if="type==='photos'">
          <div class="section-photos grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-6 px-2  px-sm-4">
            <div v-for="(album,index) in albums" class="">
              <div class="md:flex flex-col">
                <div class="md:shrink-0">
                  <template v-if="index<1">
                    <NuxtLink :to="'/photo-gallery/photos/'+album.path">
                      <nuxt-img
                          preload
                          width="278"
                          height="151"
                          format="webp"
                          :src="siteURL+'/storage/images/gallery/'+album.path+'/cover/'+album.cover_photo"
                          class="h-100 w-full object-cover md:h-full hover:opacity-75"
                          :alt="album.name"
                      />
                    </NuxtLink>
                  </template>
                  <template v-else>
                    <NuxtLink :to="'/photo-gallery/photos/'+album.path">
                      <nuxt-img
                          width="278"
                          height="151"
                          format="webp"
                          loading="lazy"
                          :src="siteURL+'/storage/images/gallery/'+album.path+'/cover/'+album.cover_photo"
                          class="h-100 w-full object-cover md:h-full"
                          :alt="album.name"
                      />
                    </NuxtLink>
                  </template>
                </div>
                <div class="p-2">
                  <NuxtLink :to="'/photo-gallery/photos/'+album.path" class="block mt-1 text-tiny text-veryDarkGray hover:underline hover:opacity-75">{{album.name}}</NuxtLink>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div  v-else-if="type==='judgecards'">
          <p v-for="item in judge_cards">
            <a :href="useJudgeCards('/storage/downloads/judgecards/'+show.folder+'/'+item.download)" class=" text-tiny text-themeRed flex hover:text-darkBlue">
              <nuxt-img format="webp" src="/pdf-transparent.jpg" class="mr-2" alt="pdf icon" width="20px" height="20px" />
              <span class="themeRed">{{(item.name !== '')? item.name:item.download}}</span>
            </a>
          </p>
        </div>
        <div v-else-if="type==='videos'" >
          <div class="flex flex-col md:w-1/2 mx-auto main_slider">
            <div class="flex justify-items-center w-100 mb-4 md:mb-8 px-2 md:px-0">
              <!--            <iframe v-if="videos.length > 0" class="mx-auto" src="https://www.youtube.com/embed/Ooxba4w2NoI" width="640" height="360"-->
              <!--                    frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen/>-->
              <swiper
                  class="md:mt-0 "
                  :modules="[Navigation, Scrollbar, A11y, Thumbs]"
                  :slides-per-view="1"
                  :space-between="50"
                  :navigation="{ clickable: true }"
                  :thumbs="{ swiper: thumbsSwiper }"
              >
                <swiper-slide v-for="item in videos">
                  <iframe v-if="videos.length > 0" :title="item.title" class="mx-auto" :src="'https://www.youtube.com/embed/'+item.video_source_id" width="520" height="320"
                          frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen/>
                </swiper-slide>
              </swiper>
            </div>
            <div class="swiper-container px-2 md:px-0 small_slider">
              <swiper
                  class="md:mt-0"
                  :modules="[Navigation, Scrollbar, A11y, Thumbs]"
                  :slides-per-view="3"
                  :space-between="25"
                  :navigation="{ clickable: true }"
                  watch-slides-progress
                  @swiper="setThumbsSwiper"
              >
                <swiper-slide v-for="item in videos" class=" w-48" >
                  <img class="h-100 w-full object-cover md:h-full w-48" width="120"  :src="item.thumbnail" alt="test">

                  <!--                <iframe class="mx-auto" :src="item.video_url" width="640" height="360"-->
                  <!--                        frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen>-->
                  <!--                </iframe>-->
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="border border-gray-300 border-x-0 border-t-0">
            <button @click="sortByBreed(0)"
                    :class="(selectedBreed === 0)? '-mb-px py-2.5 px-3.5 border border-b-white rounded-b-none focus:border-b-white focus:border-gray-300 rounded hover:bg-gray-100 hover:opacity-70':'-mb-px py-2.5 px-3.5 border rounded-b-none border-white border-b-gray-300 focus:border-b-white focus:border-gray-300 rounded hover:bg-gray-100 hover:opacity-70'">
              All
            </button>
            <button v-for="breed in results_breeds" @click="sortByBreed(breed.id)"
                    :class="(selectedBreed === breed.id)? '-mb-px py-2.5 px-3.5 border border-b-white rounded-b-none focus:border-b-white focus:border-gray-300 rounded hover:bg-gray-100 hover:opacity-70':'-mb-px py-2.5 px-3.5 border rounded-b-none border-white border-b-gray-300 focus:border-b-white focus:border-gray-300 rounded hover:bg-gray-100 hover:opacity-70'">
              {{ breed.name }}
            </button>
          </div>
          <div class="flex flex-row flex-wrap justify-between py-2">
            <select class="mt-1 py-2 px-3 border focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 mb-2 sm:mb-0 w-full sm:w-auto"
                    v-model="selectedDivision" @change="sortByDivision">
              <option v-for="option in results_division_options" :value="option.id">{{ option.name }}</option>
            </select>
            <input class="py-2 px-3 border focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 mb-2 sm:mb-0 w-full sm:w-auto" type="text"
                   v-model="filter" placeholder="Search">
          </div>
          <div v-for="item in showItems">
            <div class="flex flex-wrap justify-between text-tiny px-2.5 bg-black">
              <h2 class="text-white">{{ item.division_name }} - {{ item.class_name }}</h2>
<!--              <h2 class="text-white">Internal ID: {{ item.internal_class_id }}</h2>-->
              <div class="flex justify-between">
<!--                <h2 class="text-white">Breed Name: {{ item.breed_name }}</h2>-->
                <h2 class="text-white">Entries: {{ item.entries }}</h2>
              </div>
            </div>
            <div>
              <table class="w-full">
                <thead class="border border-2 border-x-0 border-x-0 border-black">
                <tr class="text-left text-tiny">
                  <th class="font-bold text-center flex sm:block">#</th>
                  <th class="font-bold ">Horse</th>
                  <th class="font-bold">Rider</th>
                  <th class="font-bold">Owner</th>
                  <th class="font-bold text-center">Points</th>
                </tr>
                </thead>
                <tbody class="table-content-2 markup_content text-tiny">
                <tr v-for="result in item.results" class="align-top	">
                  <td class="w-[4%] text-center flex sm:block">
                    <span class="font-bold">{{ result.place }}</span>
                  </td>
                  <td class="w-[30%] ">
                    <NuxtLink v-if="result.horse_permalink" :to="'/horse/'+result.horse_permalink" class="text-darkRed hover:opacity-70 hover:text-darkBlue"><span v-html="result.horse"></span></NuxtLink>
                    <div v-else class="text-darkRed hover:opacity-70 hover:text-darkBlue"><span v-html="result.horse"></span></div>
                  </td>
                  <td class="w-[30%]">
                    <NuxtLink v-if="result.rider_permalink" :to="'/rider/'+result.rider_permalink" class="text-darkRed hover:opacity-70 hover:text-darkBlue"><span v-html="result.rider"></span></NuxtLink>
                    <div v-else class="text-darkRed hover:opacity-70 hover:text-darkBlue"><span v-html="result.rider"></span></div>
                  </td>
                  <td class="w-[30%]">
                    <NuxtLink v-if="result.owner_permalink" :to="'/owner/'+result.owner_permalink" class="text-darkRed hover:opacity-70 hover:text-darkBlue"><span v-html="result.owner"></span></NuxtLink>
                    <div v-else class="text-darkRed hover:opacity-70 hover:text-darkBlue"><span v-html="result.owner"></span></div>
                  </td>
                  <td class="w-[6%] text-center">
                    {{
                      ((result.horse_points > 0) ? result.horse_points : ((result.rider_points > 0) ? result.rider_points : 'n/a'))
                    }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <LoadersSpinner />
    </div>
  </div>
</template>
<script setup>
import {computed, onMounted, onUpdated, ref, watch} from 'vue';
import {http} from "~/utils/http";
import {Show,Page} from "~/composables/nhTypes";
import useDebouncedRef from '~/composables/useDebouncedRef'
import { Navigation, Pagination, Scrollbar, A11y, Thumbs } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import { useJudgeCards } from "~/composables";
import {navigateTo, useHead} from "nuxt/app";
import {useSiteTitle,useSiteURL} from "~/composables/state";
import { useMainStore, useDomainStore} from '~/stores/main'

const siteURL = useSiteURL();
const siteTitle = useSiteTitle();
const router = useRouter();
const isLoggedIn = ref(true);
const thumbsSwiper = ref(null);
const setThumbsSwiper = (swiper) => {
  thumbsSwiper.value = swiper;
};
const route = useRoute();
const slug = route.params.slug;
const type = ref(route.params.type[0]?? '');
const show = ref(new Show());
const filter = useDebouncedRef('', 500);
const options = ref([
  {id: 0, name: 'Select number of horses'},
  {id: 1, name: '<100'},
  {id: 2, name: '100-199'},
  {id: 3, name: '200-299'},
  {id: 4, name: '300-399'},
  {id: 5, name: '400-499'},
  {id: 6, name: '500-599'},
  {id: 7, name: '600-699'},
  {id: 8, name: '700-799'},
  {id: 9, name: '800-899'},
  {id: 10, name: '900-999'},
  {id: 11, name: '1000+'},
])
const results_breeds = ref([]);
const results_division = ref([]);
const results_division_options = ref([]);
const results_class_settings = ref([]);
const items = ref([]);
const selectedBreed = ref(0);
const selectedDivision = ref(0);
const errors = ref('');
const judge_cards = ref([]);
const videos = ref([]);
const albums = ref([]);
const ready = ref(false);
const page = ref(new Page());
const limit = ref(10);
const showItems = computed( () => items.value.slice(0,limit.value))
const idToken = useCookie("idToken");
const arabian = ref(siteTitle.value.includes('Arabian'));
const mainStore = useMainStore()
const userName = computed(() => mainStore.userName)
const domainStore = useDomainStore();
const logo_white = computed(() => domainStore.logo_white);

useHead({
  title: computed(() => page.value.meta_title + ' - ' + siteTitle.value) ,
  meta: [
    {name: 'description', content: computed(() => page.value.meta_description)},
    {name: 'keywords', content: computed(() => page.value.meta_keywords)},
    { property: 'og:title', content: computed(() => page.value.meta_title + ' - ' + siteTitle.value) },
    { property: 'og:type', content: 'article' },
    { property: 'og:description', content: computed(() => page.value.meta_description) },
    { property: 'og:url', content:computed(() =>route.fullPath) },
  ],
})

results_division.value.push({
  id: 0,
  name: 'All Divisions',
  breed_id: 0,
});

const changePage = (page)=>{
  type.value = page;
  let baseUrl = window.location.origin + "/horse-shows/" + show.value.permalink + "/"+page;
  window.history.pushState('', '', baseUrl);
}

const getData = async () => {
  ready.value = false;

  try {
    await http
        .get("/api/event/" + slug)
        .then((response) => {
          show.value.name = response.data.show_result.name;
          show.value.city = response.data.show_result.city;
          show.value.permalink = response.data.show_result.permalink;
          show.value.date_start = response.data.show_result.date_start;
          show.value.date_end = response.data.show_result.date_end;
          show.value.state = response.data.show_result.state_province.abbreviation;
          show.value.judge = response.data.show_result.result.judge;
          show.value.usaf = !!response.data.show_result.result.usaf;
          show.value.final_form = !!response.data.show_result.result.final_form;
          show.value.nr_of_horses = response.data.show_result.result.nr_of_horses;
          show.value.photo_link = response.data.show_result.result.photo_link ?? false;
          show.value.videos = response.data.show_result.videos.length > 0;
          show.value.judge_cards = response.data.show_result.judge_cards.length > 0;
          show.value.albums = response.data.show_result.albums.length > 0;
          show.value.folder = response.data.folder;
          judge_cards.value = response.data.show_result.judge_cards;
          videos.value = response.data.show_result.videos;
          albums.value = response.data.show_result.albums;
          let aa = false;

          page.value.meta_title = response.data.show_result.meta_title;
          page.value.meta_description = response.data.show_result.meta_description;
          page.value.meta_keywords = response.data.show_result.meta_keywords;

          let diff = new Intl.DateTimeFormat('default', {    timeZone: 'utc',day: 'numeric'}).format(new Date(response.data.show_result.date_end)) - new Intl.DateTimeFormat('default', {    timeZone: 'utc',day: 'numeric'}).format(new Date(response.data.show_result.date_start))
          if (response.data.show_result.result.usaf === 1 && response.data.show_result.result.nr_of_horses > 1 && ((!arabian.value && diff >= 2) || arabian.value)) {
            aa = true;
          }
          show.value.aa = aa;

          results_class_settings.value =response.data.results_class_settings;
          // results_breeds.value =response.data.results_breeds;
          // results_division.value = response.data.results_division;
          response.data.results_breeds.forEach((item)=>{
            results_breeds.value.push(item);
          });
          response.data.results_division.forEach((item)=>{
            results_division.value.push(item);
          });

          results_division_options.value = results_division.value;

          results_breeds.value = results_breeds.value.sort((a, b) => {
            if (a.id < b.id) {
              return -1
            }
            if (a.id > b.id) {
              return 1
            }
            return 0
          })

          results_division.value = results_division.value.sort((a, b) => {
            if (a.name < b.name) {
              return -1
            }
            if (a.name > b.name) {
              return 1
            }
            return 0
          })

          if (show.value.final_form) {
            results_class_settings.value = results_class_settings.value.sort((a, b) => a.breed_id - b.breed_id || a.division_order - b.division_order || a.class_order - b.class_order)
          } else {
            results_class_settings.value = results_class_settings.value.sort((a, b) => a.breed_id - b.breed_id || a.internal_class_id - b.internal_class_id)
          }
          items.value = results_class_settings.value;
        });
  } catch (e) {
    if(e.response?.status === 403 || e.response?.status === 401){
      isLoggedIn.value = false;
    }
    ready.value = true;
  }
  ready.value = true;
}

const sortByBreed = (breed_id) => {
  selectedBreed.value = breed_id;
  selectedDivision.value = 0;
  if (breed_id > 0) {
    items.value = results_class_settings.value.filter(item =>
        item.breed_id === breed_id
    );
    results_division_options.value = results_division.value.filter(item =>
        item.breed_id === breed_id || item.id === 0
    );
  } else {
    items.value = results_class_settings.value;
    results_division_options.value = results_division.value;
  }
  sort(filter.value);
}

const sortByDivision = () => {
  if (selectedDivision.value > 0) {
    items.value = results_class_settings.value.filter(item =>
        item.division_id === selectedDivision.value
    );
    sort(filter.value);
  } else {
    sortByBreed(selectedBreed.value);
  }
}

const sort = (value) =>{
    if (value.trim().length > 0){
      items.value = items.value.filter(item => {
        return item.results.filter(result =>
            result.horse.toLowerCase().includes(value.toLowerCase())
            || result.rider.toLowerCase().includes(value.toLowerCase())
            || result.owner.toLowerCase().includes(value.toLowerCase())
        ).length > 0;
      });
    }

    items.value.forEach(item => {
      item.results.forEach(result => {
            if (value.trim().length > 0 && result.horse.toLowerCase().includes(value.toLowerCase())) {
              result.horse = "<span class='bg-amber-500 text-slate-900'>" + result.horse + "</span>";
            }
            else{
              result.horse = result.horse.replaceAll("<span class='bg-amber-500 text-slate-900'>","").replaceAll("</span>","")
            }
            if (value.trim().length > 0 && result.rider.toLowerCase().includes(value.toLowerCase())) {
              result.rider = "<span class='bg-amber-500 text-slate-900'>" + result.rider + "</span>";
            }
            else{
              result.rider = result.rider.replaceAll("<span class='bg-amber-500 text-slate-900'>","").replaceAll("</span>","")
            }
            if (value.trim().length > 0 && result.owner.toLowerCase().includes(value.toLowerCase())) {
              result.owner = "<span class='bg-amber-500 text-slate-900'>" + result.owner + "</span>";
            }
            else{
              result.owner = result.owner.replaceAll("<span class='bg-amber-500 text-slate-900'>","").replaceAll("</span>","")
            }
          }
      );
    });
}


const checkUser = async() =>{
  ready.value = false;
  try{
    if(idToken.value){
      await http.get('/api/checkUser').then(async (response) => {
        if (!response.data.subscriber || response.data.limiting_results) {
          isLoggedIn.value = false;
          ready.value = true;
        }
      })
    }
    else{
      isLoggedIn.value = false;
      ready.value = true;
    }
  }catch (e){
    if(e.response?.status === 403 || e.response?.status === 401){
      isLoggedIn.value = false;
      ready.value = true;
    }
  }
}

const getEvent = async () => {
  try {
    await http
        .get("/api/event/calendar_" + slug)
        .then((response) => {
          show.value.name = response.data.show_result.name;
          show.value.city = response.data.show_result.city;
          show.value.permalink = response.data.show_result.permalink;
          show.value.date_start = response.data.show_result.date_start;
          show.value.date_end = response.data.show_result.date_end;
          show.value.state = response.data.show_result.state_province.abbreviation;
          show.value.judge = response.data.show_result.result.judge;
          show.value.usaf = !!response.data.show_result.result.usaf;
          show.value.final_form = !!response.data.show_result.result.final_form;
          show.value.nr_of_horses = response.data.show_result.result.nr_of_horses;
          show.value.photo_link = response.data.show_result.result.photo_link ?? false;
          show.value.videos = response.data.show_result.videos.length > 0;
          show.value.judge_cards = response.data.show_result.judge_cards.length > 0;
          show.value.albums = response.data.show_result.albums.length > 0;
          show.value.folder = response.data.folder;
          judge_cards.value = response.data.show_result.judge_cards;
          videos.value = response.data.show_result.videos;
          albums.value = response.data.show_result.albums;

          let aa = false;

          if(response.data.show_result.result){
            let diff = new Intl.DateTimeFormat('default', {    timeZone: 'utc',day: 'numeric'}).format(new Date(response.data.show_result.date_end)) - new Intl.DateTimeFormat('default', {    timeZone: 'utc',day: 'numeric'}).format(new Date(response.data.show_result.date_start))

            if (response.data.show_result.result.usaf === 1 && response.data.show_result.result.nr_of_horses > 1 && ((!arabian.value && diff >= 2) || arabian.value)) {
              aa = true;
            }

            show.value.aa = aa;
          }

          page.value.meta_title = response.data.show_result.meta_title;
          page.value.meta_description = response.data.show_result.meta_description;
          page.value.meta_keywords = response.data.show_result.meta_keywords;
        });
  } catch (e) {
  }
};


watch(filter, (value) => {
  sortByDivision();
  sort(value);
})

const start = async () => {
  ready.value = false;
  checkUser();
  if(idToken.value) {
   await getData();
  }
  else{
    isLoggedIn.value = false;
  }
  ready.value = true;

  // await Promise.all([getData(),checkUser()]);
}

await getEvent();
start();

onMounted(() => {
  window.onscroll = () => {
    let bottomOfWindow =
      (  document.documentElement.scrollTop + window.innerHeight ===
        document.documentElement.offsetHeight) ||   document.documentElement.scrollTop + window.innerHeight >
        document.documentElement.offsetHeight-450;
    if (bottomOfWindow) {
      limit.value = limit.value+10;
      if(limit.value > items.value.length && items.value.length > 0){
        limit.value = items.value.length;
      }
    }
  };
});
</script>
